import { useShallow } from "zustand/react/shallow";

import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";

import { ParticipantItem } from "./participant-item";

type RaisedHandListProps = {
  search: string | null;
};

export function RaisedHandList({ search }: RaisedHandListProps) {
  const raisedHands = useVidyoStore(
    useShallow((s) =>
      [...s.participants.participants]
        .filter((p) => p.isHandRaised)
        .sort((a, b) => a.handRaisedAt.getTime() - b.handRaisedAt.getTime()),
    ),
  );

  const filteredRaisedHands = raisedHands.filter((p) =>
    p.name.toLowerCase().includes(search?.toLowerCase() ?? ""),
  );

  // If there are no raised hands, return null
  // the filteredRaisedHands may be empty, but we need to display a not-found message
  if (raisedHands.length === 0) {
    return null;
  }

  return (
    <div className="m-2 rounded-md border border-input bg-card">
      <p className="px-4 py-3 text-sm text-foreground">
        Raised Hands{" "}
        <span className="inline-flex items-center">
          <span className="inline-flex size-6 items-center justify-center rounded-full bg-border text-xs text-foreground">
            {raisedHands.length}
          </span>
        </span>
      </p>
      {filteredRaisedHands.length === 0 ? (
        <p className="border-t border-input px-4 py-3 text-sm text-foreground">
          No participants found
        </p>
      ) : (
        <ul className="divide-y divide-input border-t border-input">
          {filteredRaisedHands.map((participant) => (
            <ParticipantItem
              key={participant.participantId}
              participant={participant}
            />
          ))}
        </ul>
      )}
    </div>
  );
}
